import { NodeSandbox } from "@codemod.com/codemod-sandbox/node";

import type { WasmLang } from "./types";

export * from "./constants";
export * from "./types";

async function getWasmBasePath() {
  try {
    const getConfig = await import("next/config");
    const config = getConfig.default() as unknown as {
      serverRuntimeConfig: {
        APP_PUBLIC_DIR?: string;
      };
    };
    return config.serverRuntimeConfig.APP_PUBLIC_DIR ?? "/";
  } catch {
    return "/";
  }
}

export async function getAstGrepWasmForLang(lang: WasmLang) {
  const { readFile } = await import("node:fs/promises");
  const path = await import("node:path");

  const basePath = await getWasmBasePath();

  const wasmBuffer = await readFile(
    path.join(basePath, "codemod-sandbox.wasm"),
  );
  const instance = new NodeSandbox(wasmBuffer);

  await instance.initializeTreeSitter(() =>
    path.join(basePath, "tree-sitter.wasm"),
  );
  let retries = 0;

  while (true) {
    try {
      const realLang = (lang as string) === "c_sharp" ? "csharp" : lang;
      await instance.setupParser(
        realLang,
        path.join(basePath, "parsers", `tree-sitter-${lang}.wasm`),
      );
      break;
    } catch (error) {
      retries++;
      if (retries > 2) {
        throw error;
      }
      await new Promise((resolve) => setTimeout(resolve, 100 * retries));
    }
  }

  return instance;
}
